import { render, staticRenderFns } from "./OrderUserDetail.vue?vue&type=template&id=2096ce5d&scoped=true&"
import script from "./OrderUserDetail.vue?vue&type=script&lang=js&"
export * from "./OrderUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderUserDetail.vue?vue&type=style&index=0&id=2096ce5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096ce5d",
  null
  
)

export default component.exports